import React from "react";
import { IoClose } from "react-icons/io5";
import jsPDF from "jspdf";

const ExportChat = ({ handleShowMenu, messages, userName }) => {
  const defaultUserName = userName || "You";
  const pathSegments = window.location.pathname.split("/");
  const AIAvatar = pathSegments[pathSegments.length - 1];

  const convertToCSV = (messages) => {
    const headers = ["Type", "Message"];
    const rows = messages.map((msg) => [msg.type, msg.text]);

    let csvContent = "data:text/csv;charset=utf-8,";
    csvContent += headers.join(",") + "\n";
    rows.forEach((row) => {
      csvContent += row.join(",") + "\n";
    });

    return encodeURI(csvContent);
  };

  const downloadCSV = () => {
    const csvContent = convertToCSV(messages);
    const link = document.createElement("a");
    link.setAttribute("href", csvContent);
    link.setAttribute("download", "chat_transcript.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const wrapText = (text, maxWidth, fontSize, pdf) => {
    const lines = [];
    const words = text.split(" ");
    let line = "";

    pdf.setFontSize(fontSize);
    for (let i = 0; i < words.length; i++) {
      const testLine = line + words[i] + " ";
      const textWidth = pdf.getTextWidth(testLine);

      if (textWidth > maxWidth) {
        lines.push(line.trim());
        line = words[i] + " ";
      } else {
        line = testLine;
      }
    }
    lines.push(line.trim());

    return lines;
  };

  const downloadPDF = () => {
    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 10;
    const fontSize = 12;
    const lineHeightSame = fontSize * 0.5;
    const lineHeightDifferent = fontSize * 1;
    let y = margin + lineHeightDifferent;

    doc.setFontSize(fontSize);
    doc.text("Chat Transcript", margin, y);
    y += lineHeightDifferent;

    messages.forEach((msg, index) => {
      const isAI = msg.type === "ai";
      const marker = isAI ? `[${AIAvatar}]: ` : "";
      const text = `${marker}${
        msg.type === "user" ? `${defaultUserName}: ` : ""
      }${msg.text}`;
      const lines = wrapText(text, pageWidth - 2 * margin, fontSize, doc);

      lines.forEach((line, lineIndex) => {
        if (y + lineHeightSame > doc.internal.pageSize.height - margin) {
          doc.addPage();
          y = margin;
        }
        doc.text(line, margin, y);
        y += lineHeightSame;
      });

      if (
        index < messages.length - 1 &&
        messages[index + 1].type !== msg.type
      ) {
        y += lineHeightDifferent - lineHeightSame;
      }
    });

    doc.save("chat_transcript.pdf");
  };

  return (
    <div className="ExportChat">
      <div className="transcript__header">
        <div>
          <h1 className="transcript-title">Chat Transcript</h1>
        </div>
        <div className="transcript__close" onClick={handleShowMenu}>
          <IoClose />
        </div>
      </div>

      <div className="transcript__main-content">
        {messages.map((msg, index) => (
          <div key={index} className={`transcript__${msg.type}--message`}>
            {msg.type === "user" && (
              <p className="bubble-chat__username">{defaultUserName}</p>
            )}
            {msg.text}
          </div>
        ))}
      </div>

      <div className="transcript__download-button">
        <button onClick={downloadCSV}>Download CSV</button>
        <button onClick={downloadPDF}>Download PDF</button>
      </div>
    </div>
  );
};

export default ExportChat;
